export enum StudentType {
    FTIC = 'FTIC',
    Transfer = 'Transfer'
}